import { CODE_LENGTH } from "../constants/Constants";

export const generateCode = () => {
    const chars = [ "A", "B", "C", "D", "E", "F", "G", "H",
        "J", "K", "L", "M", "N", "P", "Q", "R",
        "T", "U", "V", "W", "X", "Y", "Z" ];
    let gameCode = "";
    for (let idx = 0; idx < CODE_LENGTH; idx++) {
        const charIdx = Math.floor(Math.random() * chars.length);
        gameCode += chars[charIdx];
    }

    return gameCode;
}